import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs";

import { LoginService } from 'app/shared';



@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  host: {
    'class': 'd-flex flex-column flex-grow-0 flex-shrink-0 align-items-center justify-content-center w-100 vh-100 overflow-visible'
  }
})
export class ErrorComponent implements OnInit, OnDestroy {
  errorMessage: string;
  error403: boolean;
  private routeSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.routeSubscription = this.route.url.subscribe((url) => {
      if (url[0].path === 'accessdenied') {
        this.error403 = true;
      }
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  login(): void {
    this.loginService.logout()
      .subscribe((): void => {
        this.router.navigate(['/auth', 'sign-in']);
      });
  }
}
